import { state } from '@angular/animations';
import { formatDate } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { element } from 'protractor';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-labels-of-hand-delivery',
  templateUrl: './labels-of-hand-delivery.component.html',
  styleUrls: ['./labels-of-hand-delivery.component.scss'],
})
export class LabelsOfHandDeliveryComponent implements OnInit {
  labelsData;
  publish_date;
  state;
  sub_mode;
  vitarandate;
  ankdate;
  tempdata;
  total_sub_count;
  data1 = [];
  FilteredlabelsData = [];
  disRepData = [];
  dataone: any;
  datatwo: any;
  combinedList: any;
  dispatchdate: any;
  dist_name: any;
  dis_mode: any;
  dis_sub_mode: any;
  filteredList: any;
  isuuedate: any;

  dis_date: any;
  updateStatus: any = false
  dataService: any;
  originalData: any;

  constructor(
    private dialogref: MatDialogRef<LabelsOfHandDeliveryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

district:any
taluka :any
pincode :any
showFilteredData: boolean = true;
  ngOnInit(): void {
    debugger;
    this.dist_name = this.data.dist_name,
      this.dis_mode = this.data.dis_mode,
      this.dis_sub_mode = this.data.dis_sub_mode,
      this.isuuedate = this.data.isuuedate,
      this.dispatchdate = this.data.dispatchdate,
      this.updateStatus = this.data.updateStatus,
     this.state = this.data.state;
    this.district = this.data.district;
    this.taluka = this.data.taluka,
    this.pincode = this.data.pincode,


      this.dataone = this.data.data1,
      // this.datatwo = this.data.data2,  // Show Extra Labels 
      this.dispatchdate = this.data.dispatchdate
    console.log(this.dataone, this.datatwo, "intial data")
    // this.service
    //   .getDistributionRepresentativeSBhetHastewise()
    //   .subscribe((res) => {
    //     this.disRepData = res;
    //     // console.log(this.disRepData);


    //   });
    // *************************COMMENTED CODE IS PREVIOUS CODE*******************************************************
    // this.labelsData = this.data['data'].filter((a) => {
    //   return a['dis_mode'] ===this.data['dis_mode'];
    // });
    this.dis_mode = this.data['dis_mode'];
    this.sub_mode = this.data['dis_sub_mode'];
    this.dis_date = this.data['dispatchdate']

    this.combinedList = this.dataone;

    console.log(this.combinedList, "Intial list")

      this.showFilteredData = this.updateStatus;
    
    if (this.updateStatus) {
  
      console.log(this.filteredList, "filterlist")
    this.getDistrictwiseStatementList();
    } else {
      this.getparcelLabel();
    }



  }


  saveSubscriptionBarcodesDataEntry() {
    console.log(this.filteredList);
    const filteredData = this.filteredList.map((item) => ({
      issue_date: this.isuuedate,
      country: "भारत",
      // state: item.state,
      number_of_subscribers: item.sub,
      total: this.total_sub_count,
      added_by: 1,
      // publish_date: this.convertDateFormat(this.dispatchdate),
      delivery_mode: item.delivery_mode,
      // dispatch_date: this.convertDateFormat(this.dispatchdate),
      dis_mode: this.dis_mode,
      dis_sub_mode: this.dis_sub_mode,
      // no_of_books_in_bundle: item.parcel.split("=")[1],
      //bundle_count: item.parcel.split("=")[0],
      // district: item.district,
      distribution_mode: item.dis_mode,
      sub_distribution_mode: item.dis_sub_mode,
      parcel_label_username_address: item.full_add,
      parcel_label_username_mobile_no: item.mob_no,
      parcel_label_pieces: item.prati,
      parcel_label_username: item.issueSellerName,
      state: item.state,
      allDistributerId:item.id,
      district: item.district,
      taluka : item.taluka,
      pincode: item.pincode,
      dispatch_date: item.dispatch_date,
      publish_date: item.publish_date,


    }));
    console.log(filteredData);
    this.service.saveParcelLabelDataEntry(filteredData).subscribe((data) => {
      alert('parcel Label Save Successfully!');
    });
  }

  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }
  // getparcelLabel() {
  //   const request = {
  //     issue_date: this.isuuedate,
  //     country: "भारत",
  //     // districts:this.district,
  //     // state: this.state
  //   }
  //   this.service.getparcelLabel(request).subscribe((data: any) => {
  //     // this.filteredList = data
  //     this.filteredList = (data || []).filter(item => Number(item.prati) !== 0);
  //   });
  // }

getparcelLabel() {

  const request = {
    issue_date: this.isuuedate,
    country: "भारत",
  };

  this.service.getparcelLabel(request).subscribe((data: any) => {

    const normalize = (val: any) =>
      (val || '').toString().trim().toLowerCase();

    // ✅ Step 1: Remove 0 prati
    let list = (data || []).filter(item => Number(item.prati) !== 0);

    // ✅ Step 2: Apply filters (IMPORTANT FIX)
    list = list.filter((item: any) => {

      let dismodeCondition = true;
      if (this.dis_mode) {
        dismodeCondition =
          normalize(item.dis_mode) === normalize(this.dis_mode);
      }

      let dis_subModeCondition = true;
      if (this.dis_sub_mode) {
        dis_subModeCondition =
          normalize(item.dis_sub_mode) === normalize(this.dis_sub_mode);
      }

      return dismodeCondition && dis_subModeCondition;
    });

    // ✅ Step 3: Assign AFTER filtering
    this.combinedList = list;

    // ✅ Step 4: Switch (NO CHANGE)
    if (this.showFilteredData) {
      this.filteredList = list;
    } else {
      this.filteredList = this.combinedList;
    }

  });
}

sumOfTotal:any=0
  getDistrictwiseStatementList() {
    //  this.calculation();
    this.combinedList = []
    const request = {
      "issue_date": this.isuuedate,
      "stateName": this.state,
      "districtName": this.dist_name,
      "talukaName": this.dist_name,
      "pincode": this.pincode,
      "distributionMode": this.dis_mode,
      "subDistributionMode": this.dis_sub_mode
    }
    this.service.getAllDistributerCopiesList(request).subscribe((data: any) => {
      this.combinedList = data.data;
      this.filteredList= data.data;
    //  this.combinedList.forEach((element:any,index)=>{
    //  element.prati=Number(element.prati)+Number(element.sale);
    //  })

     // ✅ FIX: ALWAYS CALCULATE PRATI
    this.combinedList.forEach((element: any) => {
      element.prati =
        Number(element.prati || 0) +
        Number(element.sale || 0) +
        Number(element.s_bhet || 0);
    });
      // ✅ IMPORTANT: CALL calculation
    this.calculation();

     // ✅ FINAL SWITCH
    if (!this.showFilteredData) {
      this.filteredList = [...this.combinedList]; // clone to refresh UI
    }
    });
  }
 
  // Old Method
  // calculation(){
    
  //     this.combinedList.forEach(element => {
  //       element.sub_count = 0;
  
  //     });
  
  //     for (let j = 0; j < this.datatwo.length; j++) {
  //       let matchFound = false;
  
  //       for (let i = 0; i < this.combinedList.length; i++) {
  
  //         if (this.combinedList[i].issueSellerName === this.datatwo[j].dsi_rep) {
  
  //           this.combinedList[i].sub_count = this.datatwo[j].count;
  
  //           this.combinedList[i].dist = this.datatwo[j].district;
  //           this.combinedList[i].taluka = this.datatwo[j].taluka;
  //           this.combinedList[i].state = this.datatwo[j].state;
  //           this.combinedList[i].dis_mode = this.datatwo[j].dis_mode;
  //           this.combinedList[i].dis_sub_mode = this.datatwo[j].dis_sub_mode;
  //           this.combinedList[i].dis_date = this.datatwo[j].dispatchdate;
  //           this.combinedList[i].prati = parseInt(this.combinedList[i].sub_count) + parseInt(this.combinedList[i].s_bhet);
  
  //           matchFound = true; // Set match found flag to true
  //           break; // Exit the loop as we've found a match
  //         }
  //       }
  
  //       // If no match was found, add a new object to `combinedList`
  //       if (!matchFound) {
  //         const newEntry = {
  //           issueSellerName: this.datatwo[j].dsi_rep,
  //           sub_count: this.datatwo[j].count,
  //           // state: this.datatwo[j].state,
  //           dis_dist: this.datatwo[j].district,
  //           dis_tal: this.datatwo[j].taluka,
  //           dis_mode: this.datatwo[j].dis_mode,
  //           dis_sub_mode: this.datatwo[j].dis_sub_mode,
  //           dis_date: this.datatwo[j].dispatchdate,
  //           s_bhet: 0,
  //           mob_no: this.datatwo[j].mob_no,
  //           full_add: this.datatwo[j].full_add,
  //           prati: Number(this.datatwo[j].count)+Number(this.datatwo[j].ISSUE_SELLER_COPIES)
  //         };
  
  //         this.combinedList.push(newEntry); // Add new object to `combinedList`
  //       }
  //     }
  
  //     console.log(this.combinedList, "finale combinedList list");
  
  //     // this.filteredList = this.combinedList.filter(item =>
  //     //   item.dis_mode === this.dis_mode &&
  //     //   item.dis_sub_mode === this.dis_sub_mode &&
  //     //   item.issueSellerName === this.dist_name
  //     // );
  //     debugger;
  
  
  //     this.filteredList = this.combinedList.filter((a) => {
  //       debugger;
  //       let dismodeCondition = true;
  //       if (this.dis_mode != '' && this.dis_mode != undefined) {
  //         // dismodeCondition = this.dis_mode.includes(a['dis_mode']);
  //         dismodeCondition = a['dis_mode'] !== "" && this.dis_mode === a['dis_mode'];
  
  //       }
  
  //       let dis_subModeCondition = true;
  //       if (this.dis_sub_mode != '' && this.dis_sub_mode != undefined) {
  //         // dis_subModeCondition = this.dis_sub_mode.includes(a['dis_sub_mode']);
  //         dis_subModeCondition = a['dis_sub_mode'] !== "" && this.dis_sub_mode === a['dis_sub_mode'];
  
  //       }
  
  //       let dist_nameCondition = true;
  //       if (this.dist_name != '' && this.dist_name != undefined) {
  //         // dist_nameCondition = this.dist_name.includes(a['issueSellerName']);
  //         dist_nameCondition = a['issueSellerName'] !== "" && this.dist_name === a['issueSellerName'];
  //       }
  
  //       return (
  //         dismodeCondition &&
  //         dis_subModeCondition &&
  //         dist_nameCondition
  //         // Add more conditions here
  //       );
  //     })
  // }


//Correct Code
// calculation() {

//   // ✅ Strong normalize (fixes name mismatch)
//   const normalize = (val: any) =>
//     (val || '')
//       .toString()
//       .toLowerCase()
//       .replace(/\(.*?\)/g, '') // remove brackets
//       .replace(/[^a-zA-Z0-9\u0900-\u097F]/g, '') // keep Marathi + alphanumeric
//       .trim();

//   // ✅ Step 1: Create map from combinedList
//   const map = new Map();

//   this.combinedList.forEach((item: any) => {
//     const key = normalize(item.issueSellerName);

//     map.set(key, {
//       ...item,
//       sub_count: Number(item.sub_count || 0),
//       s_bhet: Number(item.s_bhet || 0),
//       sale: Number(item.sale || 0),
//       inputValue: Number(item.inputValue || 0),
//       ISSUE_SELLER_COPIES: Number(item.ISSUE_SELLER_COPIES || 0),
//       total: item.total !== undefined ? Number(item.total) : null
//     });
//   });

//   // ✅ Step 2: Merge datatwo into map
//   this.dataone.forEach((row: any) => {
//     const key = normalize(row.dsi_rep);

//     if (map.has(key)) {
//       const existing = map.get(key);

//       // ✅ accumulate sub_count
//       existing.sub_count += Number(row.count || 0);

//       // ✅ update dispatch fields (latest overwrite OK)
//       existing.dis_dist = row.district;
//       existing.dis_tal = row.taluka;
//       existing.dis_mode = row.dis_mode;
//       existing.dis_sub_mode = row.dis_sub_mode;
//       existing.dis_date = row.dispatchdate;

//     } else {
//       // ✅ new entry
//       map.set(key, {
//         issueSellerName: row.dsi_rep,
//         sub_count: Number(row.count || 0),
//         dis_dist: row.district,
//         dis_tal: row.taluka,
//         dis_mode: row.dis_mode,
//         dis_sub_mode: row.dis_sub_mode,
//         dis_date: row.dispatchdate,
//         s_bhet: 0,
//         sale: 0,
//         inputValue: 0,
//         ISSUE_SELLER_COPIES: Number(row.ISSUE_SELLER_COPIES || 0),
//         mob_no: row.mob_no,
//         full_add: row.full_add,
//         total: row.total !== undefined ? Number(row.total) : null
//       });
//     }
//   });

//   // ✅ Step 3: Convert map → array
//   this.combinedList = Array.from(map.values());

//   // ✅ Step 4: FINAL PRATI CALCULATION (FIXED)
//   this.combinedList.forEach((item: any) => {

//     // ✅ ALWAYS PRIORITY TO BACKEND TOTAL
//     if (item.total !== null && item.total !== undefined && item.total !== '') {
//       item.prati = Number(item.total);
//     } else {

//       const sale = Number(item.sale || 0);
//       const copies = Number(item.ISSUE_SELLER_COPIES || 0);
//       const finalSale = sale > 0 ? sale : copies;

//       item.prati =
//         Number(item.sub_count || 0) +
//         Number(item.s_bhet || 0) +
//         Number(item.inputValue || 0) +
//         finalSale;
//     }
//   });

//   // ✅ Step 5: FILTER
//   const filtered = this.combinedList.filter((a: any) => {

//     let dismodeCondition = true;
//     if (this.dis_mode) {
//       dismodeCondition =
//         normalize(a.dis_mode) === normalize(this.dis_mode);
//     }

//     let dis_subModeCondition = true;
//     if (this.dis_sub_mode) {
//       dis_subModeCondition =
//         normalize(a.dis_sub_mode) === normalize(this.dis_sub_mode);
//     }

//     let dist_nameCondition = true;
//     if (this.dist_name) {
//       dist_nameCondition =
//         normalize(a.issueSellerName) === normalize(this.dist_name);
//     }

//     return dismodeCondition && dis_subModeCondition && dist_nameCondition;
//   });

//   // ✅ Step 6: FINAL SWITCH
//   if (this.showFilteredData) {
//     this.filteredList = filtered;
//   } else {
//     this.filteredList = [...this.combinedList];
//   }

//   console.log(this.filteredList, "FINAL FILTERED LIST");
// }

calculation() {

  // ✅ Strong normalize (fixes name mismatch)
  const normalize = (val: any) => {
    if (!val) return '';
    return val
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ')  // normalize spaces
      .replace(/\(.*?\)/g, '') // remove brackets
      .replace(/[^a-zA-Z0-9\u0900-\u097F\s]/g, '') // Keep Marathi + alphanumeric + spaces
      .trim();
  };

  // ✅ DEBUG: Log input data sources
  console.log('=== DATA SOURCE CHECK ===');
  console.log('combinedList length:', this.combinedList?.length || 0);
  console.log('dataone length:', this.dataone?.length || 0);
  
  // If combinedList is empty, check if there's another data source
  if (!this.combinedList || this.combinedList.length === 0) {
    console.warn('⚠️ combinedList is empty! Checking for alternative data sources...');
    
    // Option 1: Check if data is in another property
    if (this.originalData && this.originalData.length > 0) {
      console.log('✅ Found data in originalData, using it as combinedList');
      this.combinedList = [...this.originalData];
    }
    // Option 2: Check if data is in a service or store
    else if (this.dataService?.getCombinedData()) {
      const serviceData = this.dataService.getCombinedData();
      if (serviceData && serviceData.length > 0) {
        console.log('✅ Found data from service, using it as combinedList');
        this.combinedList = [...serviceData];
      }
    }
    // Option 3: If dataone has the data, use it as base
    else if (this.dataone && this.dataone.length > 0) {
      console.log('✅ Using dataone as base for combinedList');
      this.combinedList = this.dataone.map((row: any) => ({
        issueSellerName: row.dsi_rep || row.issueSellerName,
        sub_count: Number(row.count || 0),
        dis_dist: row.district,
        dis_tal: row.taluka,
        dis_mode: row.dis_mode,
        dis_sub_mode: row.dis_sub_mode,
        dis_date: row.dispatchdate,
        s_bhet: Number(row.s_bhet || 0),
        sale: Number(row.sale || 0),
        inputValue: Number(row.inputValue || 0),
        ISSUE_SELLER_COPIES: Number(row.ISSUE_SELLER_COPIES || 0),
        mob_no: row.mob_no,
        full_add: row.full_add,
        total: row.total !== undefined ? Number(row.total) : null
      }));
    }
  }

  // ✅ Step 1: Create map from combinedList
  const map = new Map();

  this.combinedList.forEach((item: any) => {
    // Try multiple possible field names for the name
    const nameValue = item.issueSellerName || item.dsi_rep || item.name || item.sellerName || '';
    const key = normalize(nameValue);
    
    // Store the original name field for reference
    const originalName = item.issueSellerName || item.dsi_rep || item.name || item.sellerName || '';

    map.set(key, {
      ...item,
      issueSellerName: originalName, // Ensure this field exists
      sub_count: Number(item.sub_count || 0),
      s_bhet: Number(item.s_bhet || 0),
      sale: Number(item.sale || 0),
      inputValue: Number(item.inputValue || 0),
      ISSUE_SELLER_COPIES: Number(item.ISSUE_SELLER_COPIES || 0),
      total: item.total !== undefined ? Number(item.total) : null,
      // Preserve all original fields
      ...item
    });
  });

  // ✅ Step 2: Merge dataone into map
  if (this.dataone && this.dataone.length > 0) {
    this.dataone.forEach((row: any) => {
      const nameValue = row.dsi_rep || row.issueSellerName || row.name || '';
      const key = normalize(nameValue);

      if (map.has(key)) {
        const existing = map.get(key);
        
        // Accumulate counts
        existing.sub_count = (existing.sub_count || 0) + Number(row.count || 0);
        
        // Update dispatch fields (only if they exist in row)
        if (row.district) existing.dis_dist = row.district;
        if (row.taluka) existing.dis_tal = row.taluka;
        if (row.dis_mode) existing.dis_mode = row.dis_mode;
        if (row.dis_sub_mode) existing.dis_sub_mode = row.dis_sub_mode;
        if (row.dispatchdate) existing.dis_date = row.dispatchdate;
        
        // Update other fields if they exist
        if (row.mob_no) existing.mob_no = row.mob_no;
        if (row.full_add) existing.full_add = row.full_add;
        if (row.total !== undefined) existing.total = Number(row.total);
        if (row.s_bhet !== undefined) existing.s_bhet = Number(row.s_bhet);
        if (row.sale !== undefined) existing.sale = Number(row.sale);
        if (row.inputValue !== undefined) existing.inputValue = Number(row.inputValue);
        if (row.ISSUE_SELLER_COPIES !== undefined) {
          existing.ISSUE_SELLER_COPIES = Number(row.ISSUE_SELLER_COPIES);
        }

      } else {
        // Create new entry from dataone
        map.set(key, {
          issueSellerName: nameValue,
          sub_count: Number(row.count || 0),
          dis_dist: row.district || '',
          dis_tal: row.taluka || '',
          dis_mode: row.dis_mode || '',
          dis_sub_mode: row.dis_sub_mode || '',
          dis_date: row.dispatchdate || '',
          s_bhet: Number(row.s_bhet || 0),
          sale: Number(row.sale || 0),
          inputValue: Number(row.inputValue || 0),
          ISSUE_SELLER_COPIES: Number(row.ISSUE_SELLER_COPIES || 0),
          mob_no: row.mob_no || '',
          full_add: row.full_add || '',
          total: row.total !== undefined ? Number(row.total) : null,
          // Preserve all other fields
          ...row
        });
      }
    });
  }

  // ✅ Step 3: Convert map → array
  this.combinedList = Array.from(map.values());
  
  console.log('✅ CombinedList after merge:', this.combinedList.length);
  console.log('Sample entry:', this.combinedList[0]);

  // ✅ Step 4: FINAL PRATI CALCULATION
  this.combinedList.forEach((item: any) => {
    // Priority to backend total
    if (item.total !== null && item.total !== undefined && item.total !== '') {
      item.prati = Number(item.total);
    } else {
      const sale = Number(item.sale || 0);
      const copies = Number(item.ISSUE_SELLER_COPIES || 0);
      const finalSale = sale > 0 ? sale : copies;

      item.prati =
        Number(item.sub_count || 0) +
        Number(item.s_bhet || 0) +
        Number(item.inputValue || 0) +
        finalSale;
    }
  });

  // ✅ Step 5: FILTER
  const filtered = this.combinedList.filter((a: any) => {
    let dismodeCondition = true;
    if (this.dis_mode) {
      dismodeCondition =
        normalize(a.dis_mode || '') === normalize(this.dis_mode);
    }

    let dis_subModeCondition = true;
    if (this.dis_sub_mode) {
      dis_subModeCondition =
        normalize(a.dis_sub_mode || '') === normalize(this.dis_sub_mode);
    }

    let dist_nameCondition = true;
    if (this.dist_name) {
      dist_nameCondition =
        normalize(a.issueSellerName || '') === normalize(this.dist_name);
    }

    return dismodeCondition && dis_subModeCondition && dist_nameCondition;
  });

  // ✅ Step 6: FINAL SWITCH
  if (this.showFilteredData) {
    this.filteredList = filtered;
  } else {
    this.filteredList = [...this.combinedList];
  }

  console.log('✅ FINAL FILTERED LIST length:', this.filteredList.length);
  
  // ✅ Log all unique names for debugging (no hardcoding)
  const uniqueNames = [...new Set(this.filteredList.map((item: any) => 
    item.issueSellerName || item.dsi_rep || 'UNKNOWN'
  ))];
  console.log('📋 All names in filtered list:', uniqueNames);
}

show = false;
//Correct Code
// printPage() {
//   const source = document.getElementById('print-section');
//   if (!source) return;

//   const printWindow = window.open('', '_blank', 'width=1400,height=900');
//   if (!printWindow) return;

//   printWindow.document.open();
//   printWindow.document.write(`
// <!DOCTYPE html>
// <html>
// <head>
// <title>Print Labels</title>

// <style>
// @page {
//   size: A4 landscape;
//   margin: 10mm;
// }

// @media print {
//   html, body {
//     margin: 0;
//     padding: 0;
//   }
// }

// /* ---------- PAGE GRID ---------- */
// .page {
//   width: 277mm;
//   height: 190mm;
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   grid-template-rows: 1fr 1fr;
//   gap: 8mm;
//   page-break-after: always;
// }

// .page:last-child {
//   page-break-after: auto;
// }

// /* ---------- CARD ---------- */
// .card {
//   border: 1px solid #000;
//   padding: 6mm;
//   box-sizing: border-box;
//   break-inside: avoid;
// }

// /* ---------- HEADER ---------- */
// .firstrow {
//   display: flex;
//   gap: 10px;
// }

// .firstrow .left img {
//   width: 90px;
// }

// .firstrow .right span,
// .name span {
//   display: block;
//   font-size: 13px;
// }

// .line {
//   border-top: 1px solid #000;
//   margin: 6px 0;
// }

// /* ---------- CONTENT ---------- */
// .maincontent {
//   font-size: 13px;
// }

// .vitaran,
// .prati {
//   display: flex;
//   justify-content: space-between;
//   font-size: 13px;
// }

// /* 🔴 FIX DISTRIBUTION DATE POSITION & FONT */
// .prati .right {
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   margin-bottom: 50px;
// }

// .prati .right .date {
//   margin-left: 200px !important;
//   margin-right: 0 !important;
//   font-size: 12px;
//   font-weight: 500;
//   white-space: nowrap;
// }

// /* ---------- MAIN BODY ---------- */
// .main {
//   display: flex;
//   gap: 16px;
//   margin-top: 6px;
//   align-items: flex-start;
// }

// .pratisankhya {
//   border: 1px solid #000;
//   min-width: 90px;
//   text-align: center;
//   padding: 6px;
// }

// /* ---------- NO PRINT ---------- */
// .noPrint {
//   display: none !important;
// }
// </style>
// </head>

// <body>

// <div id="source" style="display:none">
//   ${source.innerHTML}
// </div>

// <div id="pages"></div>

// <script>
// window.onload = function () {
//   const labels = document.querySelectorAll('#source .card');
//   const pages = document.getElementById('pages');

//   for (let i = 0; i < labels.length; i += 4) {
//     const page = document.createElement('div');
//     page.className = 'page';

//     for (let j = i; j < i + 4 && j < labels.length; j++) {
//       const card = labels[j].cloneNode(true);
//       page.appendChild(card);
//     }

//     pages.appendChild(page);
//   }

//   window.print();
//   setTimeout(() => window.close(), 500);
// };
// </script>

// </body>
// </html>
//   `);

//   printWindow.document.close();
// }

printPage() {
  const source = document.getElementById('print-section');
  if (!source) return;

  const printWindow = window.open('', '_blank', 'width=1400,height=900');
  if (!printWindow) return;

  printWindow.document.open();
  printWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
<title>Print Labels</title>

<style>
@page {
  size: A4 landscape;
  margin: 10mm;
}

@media print {
  html, body {
    margin: 0;
    padding: 0;
  }
}

/* ---------- PAGE GRID ---------- */
.page {
  width: 277mm;
  height: 190mm;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 8mm;
  page-break-after: always;
}

.page:last-child {
  page-break-after: auto;
}

/* ---------- CARD ---------- */
.card {
  border: 1px solid #000;
  padding: 6mm;
  box-sizing: border-box;
  break-inside: avoid;
}

/* ---------- HEADER ---------- */
.firstrow {
  display: flex;
  gap: 10px;
}

.firstrow .left img {
  width: 90px;
}

.firstrow .right span,
.name span {
  display: block;
  font-size: 13px;
}

.line {
  border-top: 1px solid #000;
  margin: 6px 0;
}

/* ---------- CONTENT ---------- */
.maincontent {
  font-size: 13px;
}

.vitaran {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}


/* ---------- PRATI SECTION (BELOW MAIN) ---------- */
.prati {
display: block;  
  margin-top: 10px;       /* pushes it BELOW .main */
  font-size: 13px;
}

.prati .left span {
  font-weight: 600;
}

/* Distribution date aligned right */
.prati .right {
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
  margin-bottom: 20px;
}

.prati .right .date {
 margin-left: 200px !important;
 margin-right: 0 !important;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  
}

/* ---------- MAIN BODY ---------- */
.main {
  display: flex;
  gap: 16px;
  margin-top: 6px;
  align-items: flex-start;
}

.pratisankhya {
  border: 1px solid #000;
  min-width: 90px;
  text-align: center;
  padding: 6px;
}

/* ---------- NO PRINT ---------- */
.noPrint {
  display: none !important;
}
</style>
</head>

<body>

<div id="source" style="display:none">
  ${source.innerHTML}
</div>

<div id="pages"></div>

<script>
window.onload = function () {
  const labels = document.querySelectorAll('#source .card');
  const pages = document.getElementById('pages');

  for (let i = 0; i < labels.length; i += 4) {
    const page = document.createElement('div');
    page.className = 'page';

    for (let j = i; j < i + 4 && j < labels.length; j++) {
      const card = labels[j].cloneNode(true);
      page.appendChild(card);
    }

    pages.appendChild(page);
  }

  window.print();
  setTimeout(() => window.close(), 500);
};
</script>

</body>
</html>
  `);

  printWindow.document.close();
}





}
